// Données du menu Piccola Venezia (extraites des PDFs originaux)
// Toutes les pizzas — photo extraite du PDF original, ingrédients et prix.

export const restaurant = {
  name: "Piccola Venezia",
  tagline: "L'authentique pizza italienne à Mamers",
  phone: "09 81 64 85 95",
  phoneRaw: "+33981648595",
  address: "22 rue Chevalier (Place Carnot)",
  city: "72600 MAMERS",
  country: "France",
  facebook: "piccolaveneziamamers.fr",
  hours: [
    { day: "Lundi", value: "18h – 21h30" },
    { day: "Mardi", value: "Fermé" },
    { day: "Mercredi", value: "18h – 21h30" },
    { day: "Jeudi", value: "18h – 22h" },
    { day: "Vendredi", value: "18h – 22h" },
    { day: "Samedi", value: "18h – 22h" },
    { day: "Dimanche", value: "18h – 21h30" },
  ],
};

// Toutes nos pizzas sont disponibles en deux tailles : Moyenne (Ø 29 cm) et Grande (Ø 33 cm).
export const pizzasTomate = [
  {
    slug: "margherita", name: "Margherita",
    ingredients: "sauce tomate, mozzarella, basilic",
    prices: { moyenne: 9.0, grande: 10.0 }, img: "/pizzas/margherita.webp"
  },
  {
    slug: "regina", name: "Regina",
    ingredients: "sauce tomate, mozzarella, jambon, champignons",
    prices: { moyenne: 10.0, grande: 11.5 }, img: "/pizzas/regina.webp"
  },
  {
    slug: "speciale-pizzaiolo", name: "Spéciale Pizzaïolo",
    ingredients: "sauce tomate, mozzarella, jambon, œuf, crème, ciboulette",
    prices: { moyenne: 11.5, grande: 13.0 }, img: "/pizzas/speciale-pizzaiolo.webp"
  },
  {
    slug: "3-salumi", name: "3 Salumi",
    ingredients: "sauce tomate, crème mascarpone, mozzarella, gorgonzola DOP, pancetta, jambon de Parme, jambon blanc",
    prices: { grande: 15.0 }, img: "/pizzas/3-salumi.webp"
  },
  {
    slug: "siciliana", name: "Siciliana",
    ingredients: "sauce tomate, mozzarella, anchois, thon, câpres, oignons rouges, olives noires",
    prices: { grande: 14.0 }, img: "/pizzas/siciliana.webp"
  },
  {
    slug: "vegetarienne", name: "Végétarienne",
    ingredients: "sauce tomate, mozzarella, aubergines, courgettes, poivrons, tomates cerises",
    prices: { moyenne: 11.5, grande: 13.0 }, img: "/pizzas/vegetarienne.webp"
  },
  {
    slug: "orientale", name: "Orientale",
    ingredients: "sauce tomate, mozzarella, spianata calabrese, merguez, olives noires, poivrons marinés",
    prices: { grande: 14.0 }, img: "/pizzas/orientale.webp"
  },
  {
    slug: "calzone-classique", name: "Calzone Classique",
    ingredients: "sauce tomate, mozzarella, jambon blanc, œuf, champignons",
    prices: { moyenne: 11.5, grande: 13.0 }, img: "/pizzas/calzone-classique.webp"
  },
  {
    slug: "calzone-fromage", name: "Calzone Fromage",
    ingredients: "sauce tomate, mozzarella, gorgonzola DOP, brie, fromage à raclette, chèvre, œuf",
    prices: { grande: 14.0 }, img: "/pizzas/calzone-fromage.webp"
  },
  {
    slug: "bouchere", name: "Bouchère",
    ingredients: "sauce tomate, mozzarella, viande hachée de bœuf (origine France), poivrons, tomates cerises, oignons",
    prices: { grande: 14.5 }, img: "/pizzas/bouchere.webp"
  },
  {
    slug: "fromagere", name: "Fromagère",
    ingredients: "sauce tomate, mozzarella, gorgonzola DOP, brie, fromage de chèvre",
    prices: { moyenne: 11.5, grande: 13.0 }, img: "/pizzas/fromagere.webp"
  },
  {
    slug: "4-saisons", name: "4 Saisons",
    ingredients: "sauce tomate, mozzarella, jambon blanc, champignons, artichaut, olives",
    prices: { moyenne: 11.5, grande: 13.9 }, img: "/pizzas/4-saisons.webp"
  },
  {
    slug: "neptune", name: "Neptune",
    ingredients: "sauce tomate, mozzarella, thon, oignons rouges, tomates cerises, olives",
    prices: { grande: 13.0 }, img: "/pizzas/neptune.webp"
  },
  {
    slug: "venezienne", name: "Venezienne",
    ingredients: "sauce tomate, mozzarella, jambon de Parme, tomates cerises, roquette, copeaux de parmesan",
    prices: { grande: 14.0 }, img: "/pizzas/venezienne.webp"
  },
  {
    slug: "fruits-de-mer", name: "Fruits de mer",
    ingredients: "sauce tomate, mozzarella, cocktail de fruits de mer, tomates cerises, persillade",
    prices: { grande: 14.0 }, img: "/pizzas/fruits-de-mer.webp"
  },
  {
    slug: "3-viandes", name: "3 Viandes",
    ingredients: "sauce tomate, mozzarella, viande hachée (origine France), poulet mariné, merguez",
    prices: { grande: 15.5 }, img: "/pizzas/3-viandes.webp"
  },
  {
    slug: "hawaiienne", name: "Hawaïenne",
    ingredients: "sauce tomate, mozzarella, jambon blanc, ananas, miel",
    prices: { grande: 13.0 }, img: "/pizzas/hawaiienne.webp"
  },
  {
    slug: "burger", name: "Burger",
    ingredients: "sauce tomate, mozzarella, viande hachée (origine France), oignons, cheddar, sauce burger",
    prices: { grande: 14.5 }, img: "/pizzas/burger.webp"
  },
  {
    slug: "bufala", name: "Bufala",
    ingredients: "sauce tomate, mozzarella, mozzarella Bufala, roquette, tomates cerises, basilic, copeaux de parmesan",
    prices: { grande: 13.5 }, img: "/pizzas/bufala.webp"
  },
  {
    slug: "spagnola", name: "Spagnola",
    ingredients: "sauce tomate, mozzarella, chorizo, poivrons, œuf, oignons",
    prices: { grande: 14.0 }, img: "/pizzas/spagnola.webp"
  },
  {
    slug: "bahia", name: "Bahia",
    ingredients: "sauce tomate, mozzarella, merguez, poivrons, champignons, olives, courgettes, oignons, artichauts",
    prices: { grande: 15.3 }, img: "/pizzas/bahia.webp"
  },
  {
    slug: "norvegienne", name: "Norvégienne",
    ingredients: "sauce tomate, mozzarella, saumon fumé, roquette, zestes de citron, crème fraîche",
    prices: { grande: 14.5 }, img: "/pizzas/norvegienne.webp"
  },
];

export const pizzasCreme = [
  {
    slug: "savoyarde", name: "Savoyarde",
    ingredients: "crème fraîche, mozzarella, lardons, pomme de terre, tartiflette, oignons",
    prices: { moyenne: 11.5, grande: 13.0 }, img: "/pizzas/savoyarde.webp"
  },
  {
    slug: "raclette", name: "Raclette",
    ingredients: "crème fraîche, mozzarella, lardons, pomme de terre, fromage à raclette, oignons",
    prices: { moyenne: 11.5, grande: 13.0 }, img: "/pizzas/raclette.webp"
  },
  {
    slug: "carbonara", name: "Carbonara",
    ingredients: "crème mascarpone, mozzarella, pancetta, lardons, œuf, oignons, copeaux de parmesan",
    prices: { moyenne: 12.2, grande: 14.8 }, img: "/pizzas/carbonara.webp"
  },
  {
    slug: "maya", name: "Maya",
    ingredients: "crème fraîche, mozzarella, chèvre, miel, noix, roquette, copeaux de parmesan",
    prices: { moyenne: 11.5, grande: 13.0 }, img: "/pizzas/maya.webp"
  },
  {
    slug: "campagnarde", name: "Campagnarde",
    ingredients: "crème fraîche, mozzarella, pancetta, champignons, oignons",
    prices: { moyenne: 11.3, grande: 13.0 }, img: "/pizzas/campagnarde.webp"
  },
  {
    slug: "pizza-chicken", name: "Pizza Chicken",
    ingredients: "crème fraîche, mozzarella, poulet mariné, poivrons, champignons, oignons, olives",
    prices: { moyenne: 11.3, grande: 13.0 }, img: "/pizzas/pizza-chicken.webp"
  },
  {
    slug: "kebab", name: "Kebab",
    ingredients: "crème fraîche, mozzarella, viande de kebab, tomate fraîche, oignons, cheddar, sauce blanche",
    prices: { grande: 14.0 }, img: "/pizzas/kebab.webp"
  },
];

export const burgers = [
  {
    name: "Burger Classique",
    ingredients: "steak haché (Origine France), cheddar, tomate, salade, frites",
    price: 11.0, img: "/pizzas/burger-classic.webp"
  },
  {
    name: "Burger Poulet",
    ingredients: "steak poulet pané, cheddar, tomate, salade, oignons, frites",
    price: 11.0, img: "/pizzas/burger-poulet.webp"
  },
  {
    name: "Burger Pancetta",
    ingredients: "pancetta, steak haché (Origine France), cheddar, tomate, salade, frites",
    price: 12.5, img: "/pizzas/burger-pancetta.webp"
  },
  {
    name: "Burger Omelette",
    ingredients: "omelette, steak haché (Origine France), cheddar, tomate, salade, frites",
    price: 12.5, img: "/pizzas/burger-omelette.webp"
  },
  {
    name: "Burger Montagnard",
    ingredients: "steak haché (Origine France), pomme de terre, fromage à raclette, pancetta, oignon, salade, frites",
    price: 13.5, img: "/pizzas/burger-montagnard.webp"
  },
  {
    name: "Burger Double",
    ingredients: "double steak haché (Origine France), pancetta, salade, tomate, oignon, frites",
    price: 15.5, img: "/pizzas/burger-double.webp"
  },
  {
    name: "Burger Italiano",
    ingredients: "2 steaks hachés (Origine France), roquette, tomates, oignons rouges, parmesan, pesto, mayo, frites",
    price: 16.5, img: "/pizzas/burger-italiano.webp"
  },
];

export const menuEnfant = {
  name: "Menu Enfant",
  ingredients: "Nuggets Frites OU Mini Pizza jambon + compote aux fruits",
  price: 8.0,
};

export const supplements = [
  { label: "Œuf plein air", price: 1.5 },
  { label: "Fromage (mozzarella, gorgonzola, bufala)", price: 2.5 },
  { label: "Légume", price: 1.5 },
  { label: "Poisson saumon", price: 3.5 },
  { label: "Viande (hachée)", price: 3.5 },
  { label: "Viande ( poulet, merguez)", price: 3.0 },
  { label: "Charcuterie (jambon blanc)", price: 2.5 },
  { label: "Charcuterie italienne", price: 3.5 },
];
